import React from 'react';
import { StyleSheet } from 'react-native';
import { useDispatch } from 'src/state/redux';
import { DNAButtonProps, DNAModal, DNAText, Iffy, luxColors } from '@alucio/lux-ui';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';

export const styles = StyleSheet.create({
  body: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    width: 560,
  },
  header: {
    paddingLeft: 24,
    paddingRight: 16,
    paddingBottom: 16,
    width: 560,
  },
});

interface DNACommonConfirmation {
  title?: string
  descriptionText?: string
  status?: DNAButtonProps['status']
  confirmActionText?: string
  onConfirmAction?: () => void
  hideCancelButton?: boolean
  cancelText?: string
  onCancelCallback?: () => void
  shouldAutoClose?: boolean
}

const DNACommonConfirmation:React.FC<DNACommonConfirmation> = ({
  onConfirmAction, title, status = 'primary', descriptionText, cancelText, confirmActionText,
  onCancelCallback,
  hideCancelButton,
  shouldAutoClose = true,
}) => {
  const dispatch = useDispatch()

  const closeModal = () => dispatch(DNAModalActions.closeModal())

  const onCancel = () => {
    closeModal()
    onCancelCallback?.()
  }

  const onAction = () => {
    onConfirmAction && onConfirmAction()

    shouldAutoClose && dispatch(DNAModalActions.closeModal())
  }

  return (
    <DNAModal>
      <DNAModal.Header style={styles.header} onClose={onCancel}>
        <DNAText h5 testID="confirmation-modal-header-text">{title}</DNAText>
      </DNAModal.Header>
      <Iffy is={descriptionText}>
        <DNAModal.Body style={styles.body}>
          <DNAText style={{ color: luxColors.flat.primary }}>{descriptionText}</DNAText>
        </DNAModal.Body>
      </Iffy>
      <DNAModal.Confirmation
        bodyless={!descriptionText}
        onCancel={!hideCancelButton ? onCancel : undefined}
        cancelLabel={cancelText || 'Cancel'}
        onAction={onConfirmAction ? onAction : undefined}
        actionLabel={confirmActionText}
        actionStatus={status}
      />
    </DNAModal>
  )
}

export default DNACommonConfirmation
